import { validateStoryTrailConfig, type StoryTrailConfig } from '../minigames/StoryTrailConfig.js';

export const SEQUENCE_STREAM_STORY: StoryTrailConfig = {
  id: 'sequence-stream-lantern-raft',
  skillId: 'literacy.sequence.cause-effect',
  title: 'The Lantern Raft',
  passage: [
    'Milo found three pale petals beside the stream. First, he placed the petals in a little leaf boat.',
    'A breeze pushed the boat beneath the willow branches.',
    'When the boat reached the far bank, the petals began to glow and lit the waiting lantern.',
  ].join(' '),
  // Deliberately not authored in answer order; solving requires reading the passage.
  events: [
    { id: 'lantern-lights', text: 'The glowing petals light the far-bank lantern.' },
    { id: 'petals-in-boat', text: 'Milo places the pale petals in a leaf boat.' },
    { id: 'breeze-moves-boat', text: 'A breeze carries the boat under the willow.' },
  ],
  correctOrder: ['petals-in-boat', 'breeze-moves-boat', 'lantern-lights'],
  rewardEvent: 'sequence-stream-crossing-restored',
  hint: 'Look for the words first and when. What had to happen before the lantern could shine?',
  successMessage: 'The moments connect! The stepping pages form a path across Sequence Stream.',
};

validateStoryTrailConfig(SEQUENCE_STREAM_STORY);
